import { SiFacebook, SiInstagram, SiRoku } from '@icons-pack/react-simple-icons';
import { useTranslation } from '../hooks/useTranslation'

;
import { useState } from 'react';

const Main = () => {
  const { t, currentLanguage, translateText } = useTranslation();
  const [translatedData, setTranslatedData] = useState(null);

  return (
    <div className="w-full h-[550px] text-white">
      <div className="w-full h-full">
        <div className="bg-black/60 absolute top-0 left-0 w-full h-[550px]"></div>
        <img
          className="w-full h-full object-cover"
          src={`./background.jpg`}
          alt="Banner Image"
        />
        <div className="absolute w-full top-[20%] p-4 md:p-8"></div>
        <div className="absolute w-full top-[20%] p-4 md:p-8">
          <h1 className="text-3xl md:text-5xl font-bold"> USPORTS  </h1>
          {/*                 <div>
                    <button className='border bg-gray-300 text-black border-gray-300 py-2 px-5'>Play</button>
                    <button className='border text-white border-gray-300 py-2 px-5 ml-4'>Watch Later</button>
                </div> */}
          <p className="w-full md:max-w-[70%] lg:max-w-[50%] xl:max-w-[35%] text-gray-200">
            {" "}
            {t('heroDescription')}{" "}
            <a href="https://isilive.ca">iSiLIVE</a>{" "}
          </p>
          <div className='pt-4 flex group'>
          <a href="https://www.instagram.com/usportsca/" target="_blank">          
           <SiInstagram color='#FF0069' size={40} />
          </a>
          <a className="pl-4" href="https://www.facebook.com/USPORTSCanada/" target="_blank">          
          <SiFacebook color='#0866FF' size={40} />
          </a>
{/*           <a className="pl-4" href="https://my.roku.com/account/add?channel=CQTLV6H" target="_blank">          
          <SiRoku color='#662D91' size={40} />
          </a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
